/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 * Polymorphic serializer base class.
 *
 * Note that the discriminator field must exist at the same depth as the mapped
 * serializer fields for the OpenAPI introspection. See
 * https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/ for
 * more information. As such, it's not possible to define something like:
 *
 * {
 *     "object_type": "foo",
 *     "polymorphic_context": {
 *         <foo-specific fields>
 *     }
 * }
 *
 * without explicitly wrapping this in a parent serializer, i.e. -
 * ``polymorphic_context`` can not be a PolymorphicSerializer itself, as it requires
 * access to the ``object_type`` in the parent scope.
 * @export
 * @interface PerturbedDatasetPolymorphicShared
 */
export interface PerturbedDatasetPolymorphicShared {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicShared
   */
  taskType: TaskTypeEnum;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicShared interface.
 */
export function instanceOfPerturbedDatasetPolymorphicShared(value: object): value is PerturbedDatasetPolymorphicShared {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicSharedFromJSON(json: any): PerturbedDatasetPolymorphicShared {
  return PerturbedDatasetPolymorphicSharedFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
  };
}

export function PerturbedDatasetPolymorphicSharedToJSON(value?: PerturbedDatasetPolymorphicShared | null): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
